/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
import {
  REQUEST_INVOICES,
  REQUEST_INVOICE,
  REQUEST_INVOICE_BARE,
  REQUEST_INVOICE_FILTER,
  REQUEST_EXACT_AUTH_STATUS,
  REQUEST_VAT_CODES,
  REQUEST_EXACT_AUTH_LINK,
  REQUEST_COMPANY_TRANSPORT_LOCATIONS,
  REQUEST_AMOUNTS_CALCULATIONS,
  GET_CURRENT_REST_BPM,
  REQUEST_INVOICE_STATUS_LIST,
  SET_EDIT_INVOICE_VALUE,
  INITIATE_INVOICE_EDIT,
  REQUEST_COMPANY_INVOICES,
  REQUEST_VEHICLE_INVOICES,
  REQUEST_PRODUCT_INVOICES,
  REQUEST_LEDGERS,
  REQUEST_EXACT_WEBHOOK_SUBSCRIPTIONS,
  REQUEST_LAST_PRODUCT_INVOICE_ID,
} from './constants';

import { REQUEST_DATA_RESULT } from '../../containers/App/constants';
import { parseStoreCompany } from '../Companies/helpers';
import { REQUEST_COMPANY } from '../Companies/constants';

const stringToDate = raw => (raw ? new Date(raw) : null);

const mapInvoiceListItem = raw => {
  if (!raw) return null;
  let relation = null;
  if (raw.direction === 'incoming') {
    const incomingCompany = raw.incomingCompany ? parseStoreCompany(raw.incomingCompany) : null;
    relation = incomingCompany?.name ?? null;
  }

  if (raw.direction === 'outgoing') {
    const outgoingCompany = raw.outgoingCompany ? parseStoreCompany(raw.outgoingCompany) : null;
    relation = outgoingCompany?.name ?? null;
  }

  return {
    ...raw,
    relation,
  };
};

const mapInvoice = raw => {
  const incomingCompany = raw.incomingCompany ? parseStoreCompany(raw.incomingCompany) : null;
  const outgoingCompany = raw.outgoingCompany ? parseStoreCompany(raw.outgoingCompany) : null;
  const incomingCompanyLabel = incomingCompany?.name ?? incomingCompany?.name ?? null;

  const outgoingCompanyLabel =
    outgoingCompany?.name && outgoingCompany?.surname
      ? outgoingCompany?.name + ' ' + outgoingCompany?.surname
      : outgoingCompany?.name
      ? outgoingCompany?.name
      : null;

  return {
    ...raw,
    date: stringToDate(raw.date),
    dueDate: stringToDate(raw.dueDate),
    paidDate: stringToDate(raw.paidDate),
    desiredDeliveryDate: stringToDate(raw.desiredDeliveryDate),
    buyerId: raw.userBuyer ? raw.userBuyer.id : null,
    buyerLabel: raw.userBuyer ? raw.userBuyer.email_address : null,
    sellerId: raw.userSeller ? raw.userSeller.id : null,
    sellerLabel: raw.userSeller ? raw.userSeller.email_address : null,
    creatorId: raw.userCreator ? raw.userCreator.id : null,
    creatorLabel: raw.userCreator ? raw.userCreator.email_address : null,
    incomingCompanyId: incomingCompany ? incomingCompany.id : null,
    incomingCompanyLabel,
    outgoingCompanyId: outgoingCompany ? outgoingCompany.id : null,
    outgoingCompanyLabel,
    incomingUserId: raw.incomingUser ? raw.incomingUser.email_address :  raw?.incomingUserId?  raw?.incomingUserId : null,
    incomingUserLabel: raw.incomingUser ? raw.incomingUser.email_address : null,
    outgoingUserId: raw.outgoingUser ? raw.outgoingUser.email_address : null,
    outgoingUserLabel: raw.outgoingUser ? raw.outgoingUser.email_address : null,
    typeLabel: raw.type,
    directionLabel: raw.direction,
    status: raw.status ? raw.status.id : null,
    statusLabel: raw.status ? raw.status.name : null,
    incomingCompany,
    outgoingCompany,
    import: raw.vehicle?.import,
  };
};

const getCompanyTransportLocations = company => {
  const addresses = company?.addresses ?? [];
  return addresses.filter(a => a.type?.name === 'delivery');
};

export const initialState = {
  invoices: [],
  invoicesById: {},
  companyInvoices: [],
  vehicleInvoices: [],
  newInvoice: {},
  statuses: [],
  filter: {
    searchString: null,
    offset: 0,
    direction: null,
    isFinal: null,
  },
  itemsCount: 0,
  exactVatCodes: [],
  company: null,
  calculations: null,
  fetchedBPM: {
    autotelexRestBpm: null,
    autotelexGrossBpm: null,
    currentRestBpm: null,
    grossBpm: null,
    purchaseRestBpm: null,
  },
};

export const invoiceReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case REQUEST_INVOICE_FILTER:
        if (action.name) {
          if (action.name === 'clear') {
            draft.filter = {
              searchString: null,
              offset: 0,
              direction: null,
              isFinal: null,
            };
          } else {
            if (action.value === null) {
              delete draft.filter[action.name];
            } else {
              draft.filter[action.name] = action.value;
            }
            //reset offset
            if (action.name !== 'offset') draft.filter.offset = 0;
          }
        }
        break;
      case REQUEST_PRODUCT_INVOICES:
        draft.productInvoices = [...action.result.items.map(i => mapInvoiceListItem(i))];
        draft.paginator = action.result.paginator;
        draft.itemsCount = action.result.paginator.itemsCount;
        draft.invoices.forEach(i => {
          if (!draft.invoicesById[i.id]) draft.invoicesById[i.id] = i;
        });
        break;
      case INITIATE_INVOICE_EDIT:
        try {
          draft.newInvoice = {
            id: action.id,
          };
          let invoice = draft.invoicesById[action.id];

          draft.newInvoice = { id: invoice?.id };
        } catch (e) {
          // eslint-disable-next-line no-debugger
          debugger;
        }
        break;
      case SET_EDIT_INVOICE_VALUE:
        if (action.initiate) {
          draft.newInvoice[action.name] = draft.newInvoice[action.name] || '';
        } else draft.newInvoice[action.name] = action.value;
        if (action.reset) {
          draft.newInvoice = {};
        }
        return;
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case REQUEST_INVOICES:
            draft.invoices = [...action.result.items.map(i => mapInvoiceListItem(i))];
            draft.paginator = action.result.paginator;
            draft.itemsCount = action.result.paginator.itemsCount;
            draft.invoices.forEach(i => {
              if (!draft.invoicesById[i.id]) draft.invoicesById[i.id] = i;
            });
            break;
          case REQUEST_COMPANY_INVOICES:
            draft.companyInvoices = [...action.result.items.map(i => mapInvoiceListItem(i))];
            draft.paginator = action.result.paginator;
            draft.itemsCount = action.result.paginator.itemsCount;
            break;
          case REQUEST_VEHICLE_INVOICES:
            draft.vehicleInvoices = [...action.result.items.map(i => mapInvoiceListItem(i))];
            draft.paginator = action.result.paginator;
            draft.itemsCount = action.result.paginator.itemsCount;
            break;
          case REQUEST_PRODUCT_INVOICES:
            draft.invoices = [...action.result.items.map(i => mapInvoiceListItem(i))];
            console.log('product invoices', draft.invoices);
            draft.paginator = action.result.paginator;
            draft.itemsCount = action.result.paginator.itemsCount;
            draft.invoices.forEach(i => {
              if (!draft.invoicesById[i.id]) draft.invoicesById[i.id] = i;
            });
            break;
          case REQUEST_LAST_PRODUCT_INVOICE_ID:
            draft.latestProductInvoiceId = action.result;
            break;
          case REQUEST_INVOICE:
            draft.invoice = mapInvoice(action.result);
            draft.invoicesById[action.result?.id] = mapInvoice(action.result);
            break;
          case REQUEST_INVOICE_BARE:
            draft.invoiceBare = mapInvoice(action.result);
            break;
          case REQUEST_INVOICE_STATUS_LIST:
            draft.statuses = action.result;
            break;
          case GET_CURRENT_REST_BPM:
            draft.fetchedBPM = {
              ...action.result,
              autotelexRestBpm: !isNaN(+action.result.autotelexRestBpm) ? +action.result.autotelexRestBpm : null,
              autotelexGrossBpm: !isNaN(+action.result.autotelexGrossBpm) ? +action.result.autotelexGrossBpm : null,
            };
            break;
          case REQUEST_AMOUNTS_CALCULATIONS:
            draft.calculations = action.result;
            break;
          case REQUEST_EXACT_AUTH_STATUS:
            draft.exactAuthStatus = action?.result?.isAuthorized ?? false;
            break;
          case REQUEST_VAT_CODES:
            draft.vatCodes = action.result;
            break;
          case REQUEST_LEDGERS:
            draft.ledgers = action.result;
            break;
          case REQUEST_EXACT_AUTH_LINK:
            draft.exactAuthInitialLink = action.result;
            break;
          case REQUEST_COMPANY:
            draft.company = action.result;
            break;
          case REQUEST_COMPANY_TRANSPORT_LOCATIONS:
            try {
              const company = action.result;
              draft.companyTransportLocations = getCompanyTransportLocations(company);
            } catch (err) {
              //
            }
            break;
          case REQUEST_EXACT_WEBHOOK_SUBSCRIPTIONS:
            draft.webhooks = action?.result ?? [];
            break;
        }
    }
  });
